import React, { useCallback, useEffect, useRef, useState } from 'react';

import NextButton from './next_button';
import axios from '../axios';
import Name from './name';
import ModalAlert from '../modal/modal_alert';

const Questions = ({ rurl }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonValid, setIsButtonValid] = useState(false);
  const [familyname, setFamilyname] = useState('');
  const [firstname, setFirstname] = useState('');
  const [isSuccess, setIsSuccess] = useState(true);
  const modalAlertCompleteRef = useRef(null);

  const redirectToFunc = useCallback(() => {
    if (rurl) {
      location.href = rurl;
    } else {
      location.reload();
    }
  }, [rurl]);

  useEffect(() => {
    axios.get('/api/questions/data').then((res) => {
      const data = res.data;
      if (data) {
        setFamilyname(data.currentUser.familyname || '');
        setFirstname(data.currentUser.firstname || '');
        setIsLoading(false);
      }
    });
  }, [setFamilyname, setFirstname, setIsLoading]);

  useEffect(() => {
    const isValid =
      familyname && familyname.trim() && firstname && firstname.trim()
        ? true
        : false;
    setIsButtonValid(isValid);
  }, [familyname, firstname, setIsButtonValid]);

  const submitFunc = useCallback(() => {
    axios
      .patch('/api/user', {
        user: {
          familyname: familyname,
          firstname: firstname,
        },
      })
      .then(() => {
        setIsSuccess(true);
      })
      .catch(() => {
        setIsSuccess(false);
      })
      .finally(() => {
        modalAlertCompleteRef.current.openModal();
      });
  }, [familyname, firstname]);

  return isLoading ? null : (
    <React.Fragment>
      <div
        className="pt-2"
        style={{
          marginTop: '30px',
          marginBottom: '180px',
          borderRadius: '0.25rem',
        }}
      >
        {
          <Name
            setFamilyname={(v) => setFamilyname(v)}
            setFirstname={(v) => setFirstname(v)}
            familyname={familyname}
            firstname={firstname}
          />
        }
      </div>
      <div className="fixed-bottom" style={{ height: '90px' }}>
        <div className="container col-9">
          <div className="d-flex">
            {
              <NextButton
                onClickFunc={() => submitFunc()}
                disabled={!isButtonValid}
                word="登録する"
              />
            }
          </div>
        </div>
      </div>
      <ModalAlert
        ref={modalAlertCompleteRef}
        title={isSuccess ? '登録完了' : '登録失敗'}
        content={
          isSuccess ? '登録しました。' : 'お時間をおいて再度設定してください。'
        }
        approveFunc={isSuccess ? () => redirectToFunc() : () => {}}
      />
    </React.Fragment>
  );
};

export default Questions;
